import React, { useEffect, useState } from "react";
import CuadroPaises from "./CuadroPaises.js";
import CuadroTorneosPais from "./pais/CuadroTorneosPais.js";
import MensajeCargando from "../UI/MensajeCargando.js";
import MensajeError from "../UI/MensajeError.js";
import useGetListaURL from "../../hooks/useGetListaURL.js";
import styles from "./HomeTorneos.module.css";

const HomeTorneosPaises = (props) => {
  const [principales, setPrincipales] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    fetchData("paises?principales=true", setPrincipales);
  }, [fetchData]);

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.contenedorCuadros}`}>
        {principales && principales.map((pais, index) => (
          <CuadroTorneosPais key={index} pais={pais} />
        ))}
        <MensajeCargando isCargando={isCargando} />
        <MensajeError errores={erroresGetLista} />
      </div>
      <div className={`${styles.cuadroTorneos}`} >
        <CuadroPaises titulo="Todos los paises" incluirPrincipales={false} pathLinks="/torneosPais/" />
      </div>
    </div>
  );
};

export default HomeTorneosPaises;